export const chapters = {
    "matthew": "28",
    "mark": "16",
    "luke": "24",
    "john": "21"
}